<template>
  <div class="main-content">
    <div class="left-nav">
      <div 
        class="left-nav-item" 
        v-for="nav in navs" 
        :key="nav.id"
        :class="{ 'active': active === nav.id }"
        @click="changeNav(nav.id)"
      >
        {{ nav.name }}
      </div>
    </div>
    <div class="right-content">
      <div 
        class="con-item" 
        v-for="item in navs" 
        :key="item.id"
        :ref="item.id"
      >
        <p class="title">{{ item.name }}</p>
        <p class="desc" :class="{ 'no': item.no }">
          {{ item.desc }}
        </p>
        <div v-if="item.previews" class="preview-box">
          <div 
            class="item-preview" 
            v-for="p in item.previews" 
            :key="p.id"
          >
            <img 
              class="preview-img" 
              :src="p.preview" 
              :alt="p.name"
            >
            <p class="name">{{ p.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'auth-introduce',
    data() {
      return {
        active: 'primary',
        navs: [
          {name: '初级能力认证', id: 'primary', desc: '获得初级能力认证后可申请该年度中级优化师认证考试资格 每年9月开放考试认证，证书有效期1年', previews: [
            {name: '初级优化师', preview: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/auth1.png'},
            {name: '销售顾问', preview: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/auth2.png'}
          ]},
          {name: '中级能力认证', id: 'intermediate', desc: '获得中级能力认证后可申请下一年度中级优化师认证考试资格 每年9月开放考试认证，证书有效期1年', previews: [
            {name: '中级优化师', preview: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/auth3.png'},
            {name: '资深销售顾问', preview: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/auth4.png'}
          ]},
          {name: '高级能力认证', id: 'senior', desc: 'COMING SOON', no: true},
        ]
      }
    },
    methods: {
      changeNav(id) {
        this.active = id;
        this.scrollTo(this.$refs[id][0]);
      },
      scrollTo(el) {
        let rect = el.getBoundingClientRect();
        window.scrollTo(0, rect.top + window.scrollY);
      }
    }
  }
</script>